import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import Head from '../layout/head/Head'
import Content from '../layout/content/Content'
import { useForecastData } from '../store/rawStore'
import ForecastItem from './mc-components/forecast-table/ForecastItem'

const Forecast = () => {
  const { t } = useTranslation()
  const forecast = useForecastData()

  return (
    <Fragment>
      <Head title={t('menu.forecast')}/>
      <Content>
        {forecast?.hsCodeForecasts?.map((item, index) => (<ForecastItem key={index} id={index} hsCodeForecast={item}/>))}
      </Content>
    </Fragment>
  )
}

export default Forecast
